import React from 'react';
import {Link} from 'react-router-dom';
import AurEcaBadges from '../../../aur-eca/AurEcaBadges';

const EcaBadges: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>ECA Badges</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <h3>ECA=TRUE, Doc Summary=TRUE</h3>
          <h4>Administrator</h4>
          <AurEcaBadges admin={true} docSummary={true} />
          <h4>Non-Administrator</h4>
          <AurEcaBadges admin={false} docSummary={true} />
          <br></br>
          <br></br>
          <h3>ECA=TRUE, Doc Summary=FALSE</h3>
          <h4>Administrator</h4>
          <AurEcaBadges admin={true} docSummary={false} />
          <h4>Non-Administrator</h4>
          <AurEcaBadges admin={false} docSummary={false} />
          <br></br>
          <br></br>
          <h3>Responsiveness</h3>
          <AurEcaBadges
            admin={false}
            docSummary={true}
            smallPillText="Label Lorem Ipsom Dolor Amet"
            largePillText="Label Lorem Ipsom Dolor Amet Sit Consectetur Adipiscing Elit"
          />
        </div>
      </div>
    </>
  );
};

export default EcaBadges;
